import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import ProjectsViewDefault from './Default/ProjectsView';
import ProjectsViewPlayful from './Playful/ProjectsView';
import ProjectsViewPlayfulTeacher from './PlayfulTeacher/ProjectsView';

export function ProjectsView(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  if (isPlayfulStudentTheme) return <ProjectsViewPlayful {...props} />;
  if (isPlayfulTeacherTheme) return <ProjectsViewPlayfulTeacher {...props} />;
  return <ProjectsViewDefault {...props} />;
}
